import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import confirmRegister from '../../../../assets/images/confirmRegister.png';
import { Button } from '../../../../components/Button';

interface IModalWhatsappIsOpen {
  modalIsOpen: boolean;
  toggleModal: () => void;
  phoneWhatsapp: string;
  actionTitle: string;
}

export function ModalWhatsappIsOpen({
  modalIsOpen,
  toggleModal,
  phoneWhatsapp,
  actionTitle,
}: IModalWhatsappIsOpen) {
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img
            className={styles.alert}
            src={confirmRegister}
            alt="Cadastro confirmado"
          />
        </div>
        <h1 className="title-modal">Obrigado pelas informações!</h1>
        <p className="subtitle-modal">
          Quer falar comigo agora? Me chame pelo meu WhatsApp!
        </p>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Concluir"
          type="button"
          color="primary"
          onClick={() => {
            toggleModal();
            location.href = `https://api.whatsapp.com/send?phone=55${phoneWhatsapp}&text=Olá! Gostaria de saber um pouco mais sobre a publicação: ${actionTitle}. Você pode me ajudar?`;
          }}
        />
      </div>
    </Modal>
  );
}
